import { render, staticRenderFns } from "./ProjectTable.vue?vue&type=template&id=1f6fbd26&scoped=true"
import script from "./ProjectTable.vue?vue&type=script&lang=js"
export * from "./ProjectTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6fbd26",
  null
  
)

export default component.exports